import { render, staticRenderFns } from "./weight-measurement.vue?vue&type=template&id=4e129ef4&"
import script from "./weight-measurement.vue?vue&type=script&lang=js&"
export * from "./weight-measurement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports